module.exports = __webpack_public_path__ + "images/emoji/seedling.13efbd5814747b7f3475.png";